__turbopack_context__.v({
  "actions": "PriceRangeFilter-module-scss-module__lRqEPq__actions",
  "active": "PriceRangeFilter-module-scss-module__lRqEPq__active",
  "applyButton": "PriceRangeFilter-module-scss-module__lRqEPq__applyButton",
  "chevron": "PriceRangeFilter-module-scss-module__lRqEPq__chevron",
  "clearButton": "PriceRangeFilter-module-scss-module__lRqEPq__clearButton",
  "content": "PriceRangeFilter-module-scss-module__lRqEPq__content",
  "expanded": "PriceRangeFilter-module-scss-module__lRqEPq__expanded",
  "header": "PriceRangeFilter-module-scss-module__lRqEPq__header",
  "input": "PriceRangeFilter-module-scss-module__lRqEPq__input",
  "inputGroup": "PriceRangeFilter-module-scss-module__lRqEPq__inputGroup",
  "inputs": "PriceRangeFilter-module-scss-module__lRqEPq__inputs",
  "label": "PriceRangeFilter-module-scss-module__lRqEPq__label",
  "name": "PriceRangeFilter-module-scss-module__lRqEPq__name",
  "priceFilter": "PriceRangeFilter-module-scss-module__lRqEPq__priceFilter",
  "separator": "PriceRangeFilter-module-scss-module__lRqEPq__separator",
});
